if (!customElements.get('human-difference')) {
  class HumanDifference extends HTMLElement {
    constructor() {
      super();
      this.swiper = null;
      this.desktopBreakpoint = 1024;
      this.handleResize = this.handleResize.bind(this);
    }

    connectedCallback() {
      this.handleResize();
      window.addEventListener('resize', this.handleResize);
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.handleResize);
      this.destroy();
    }

    get swiperContainer() {
      return this.querySelector('.human-difference__slider');
    }

    get slides() {
      return this.querySelectorAll('.swiper-slide');
    }

    getConfig() {
      return {
        slidesPerView: 1.1,
        slidesOffsetAfter: 12,
        slidesOffsetBefore: 12,
        spaceBetween: 12,
        centeredSlides: false,
        grabCursor: true,
        keyboard: {
          enabled: true,
        },
        breakpoints: {
          768: {
            slidesPerView: 3,
            slidesPerGroup: 1,
            spaceBetween: 12,
            slidesOffsetAfter: 20,
            slidesOffsetBefore: 20,
          },
          1024: {
            slidesPerView: 3,
            slidesPerGroup: 1,
            spaceBetween: 12,
            slidesOffsetAfter: 20,
            slidesOffsetBefore: 20,
          },
          1200: {
            slidesPerView: 3,
            slidesPerGroup: 1,
            spaceBetween: 12,
            slidesOffsetAfter: 0,
            slidesOffsetBefore: 0,
          },
        },
      };
    }

    handleResize() {
      const isDesktop = window.innerWidth >= this.desktopBreakpoint;
      const shouldUseSliderDesktop = this.slides.length > 3;

      if (isDesktop) {
        if (shouldUseSliderDesktop) {
          if (!this.swiper) this.init();
        } else if (this.swiper) {
          this.destroy();
        }
      } else if (!this.swiper) {
        this.init();
      }
    }

    init() {
      if (this.swiperContainer) {
        this.classList.add('slider-active');
        this.swiper = new Swiper(this.swiperContainer, this.getConfig());
      }
    }

    destroy() {
      if (this.swiper) {
        this.swiper.destroy(true, true);
        this.swiper = null;
      }
      this.classList.remove('slider-active');
    }
  }

  customElements.define('human-difference', HumanDifference);
}
